import { BADGE_VARIANTS } from 'components/Badge'
import { ORDER_ITEM_STATUS, ORDER_STATUS } from 'constants/common'
import { type StatusBadgeMapper } from './types'

export const ORDER_STATUS_BAGDE_VALUES: StatusBadgeMapper = {
  [ORDER_STATUS.UNPAID]: {
    variant: BADGE_VARIANTS.RED,
    text: 'Ready for payment',
  },
  [ORDER_STATUS.PROCESSING]: {
    variant: BADGE_VARIANTS.ORANGE,
    text: 'In Progress',
  },
  [ORDER_STATUS.PENDING]: {
    variant: BADGE_VARIANTS.GREEN,
    text: 'Paid',
  },
  [ORDER_STATUS.COMPLETED]: {
    variant: BADGE_VARIANTS.GREEN,
    text: 'Delivered',
  },
  [ORDER_STATUS.CANCELLED]: {
    variant: BADGE_VARIANTS.GRAY,
    text: 'Cancelled',
  },
} as const

export const ORDER_ITEM_STATUS_BAGDE_VALUES: StatusBadgeMapper = {
  [ORDER_ITEM_STATUS.PENDING]: {
    variant: BADGE_VARIANTS.GREEN,
    text: 'Paid',
  },
  [ORDER_ITEM_STATUS.PROCESSING]: {
    variant: BADGE_VARIANTS.ORANGE,
    text: 'Processing',
  },
  [ORDER_ITEM_STATUS.SHIPPED]: {
    variant: BADGE_VARIANTS.ORANGE,
    text: 'Pending delivery',
  },
  [ORDER_ITEM_STATUS.DELIVERED]: {
    variant: BADGE_VARIANTS.GREEN,
    text: 'Delivered',
  },
  [ORDER_ITEM_STATUS.CANCELLED]: {
    variant: BADGE_VARIANTS.GRAY,
    text: 'Cancelled',
  },
} as const
